// This icon file is generated automatically.
var PMinusOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.63 5.4H.37a.13.13 0 00-.12.13v.94c0 .07.06.12.13.12h11.24c.07 0 .13-.05.13-.12v-.94a.13.13 0 00-.13-.12z", "fill-rule": "nonzero" } }] }, "name": "p-minus", "theme": "outlined" };
export default PMinusOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PMinusOutlined.js
// module id = 3515
// module chunks = 0